import { render, staticRenderFns } from "./EditLayoutTemplateActions.vue?vue&type=template&id=a4fc0232&scoped=true"
import script from "./EditLayoutTemplateActions.vue?vue&type=script&lang=js"
export * from "./EditLayoutTemplateActions.vue?vue&type=script&lang=js"
import style0 from "./EditLayoutTemplateActions.vue?vue&type=style&index=0&id=a4fc0232&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4fc0232",
  null
  
)

export default component.exports